import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    name: "DEEPAK PATEL",
    avatarBg: "bg-green-100",
    avatarText: "D",
    avatarColor: "text-green-700",
    rating: 5,
    text: "I am an NRI. Recently we visited this hospital after a feedback from my friend. very impressed with the treatment facilities and the specialized dentists. I strongly recommend this hospital.",
    date: "2 months ago"
  },
  {
    name: "SYAMALA, INFOSYS",
    avatarBg: "bg-purple-100",
    avatarText: "S",
    avatarColor: "text-purple-700",
    rating: 5,
    text: "My 21 years daughter has clips treatment at this hospital and we were very pleased with the treatment. Now the alignment is very good. Thanks to Dr. Raghavendra our Orthodontist.",
    date: "a week ago"
  },
  {
    name: "DR. CHARITHA NRI",
    avatarBg: "bg-purple-100",
    avatarText: "C",
    avatarColor: "text-purple-700",
    rating: 5,
    text: "Came from Austin, USA for Christmas vacation. Had Implants with immediate loading. Very happy. Same thing might have 6 times more in USA. Strongly recommend.",
    date: "a year ago"
  },
  {
    name: "LAKSHMI PUTTAGUNTA",
    avatarBg: "bg-purple-100",
    avatarText: "L",
    avatarColor: "text-purple-700",
    rating: 5,
    text: "I took my 8 year old son who has thumb sucking habit. I consulted pedodontist . Very impressed with the treatment result and now he stopped that habit. Very happy.",
    date: "6 months ago"
  },
  // Add more real testimonials here...
];

const TestimonialSlider = () => {
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const animationRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  // Adjust this value to control scroll speed (higher = faster)
  const scrollSpeed = 0.5; // pixels per frame

  // Continuous infinite marquee animation
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let scrollPos = 0;

    const animate = () => {
      if (isPaused) {
        animationRef.current = requestAnimationFrame(animate);
        return;
      }

      scrollPos += scrollSpeed;

      // Seamless reset: when we've scrolled past one full set, jump back instantly
      if (scrollPos >= track.scrollWidth / 2) {
        scrollPos -= track.scrollWidth / 2;
        track.style.transition = 'none';           // disable transition during reset
        track.style.transform = `translateX(-${scrollPos}px)`;
        void track.offsetWidth;                    // force reflow → reset is invisible
        track.style.transition = '';               // restore smooth scrolling
      } else {
        track.style.transform = `translateX(-${scrollPos}px)`;
      }

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPaused]);

  // Pause auto-scroll on hover / touch
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const pause = () => setIsPaused(true);
    const resume = () => setIsPaused(false);

    container.addEventListener('mouseenter', pause);
    container.addEventListener('mouseleave', resume);
    container.addEventListener('touchstart', pause, { passive: true });
    container.addEventListener('touchend', resume, { passive: true });

    return () => {
      container.removeEventListener('mouseenter', pause);
      container.removeEventListener('mouseleave', resume);
      container.removeEventListener('touchstart', pause);
      container.removeEventListener('touchend', resume);
    };
  }, []);

  // Horizontal mouse wheel / trackpad support
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      // If vertical scroll is dominant → let browser handle page scroll
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        return;
      }

      // Horizontal scroll (trackpad two-finger, mouse wheel horizontal)
      e.preventDefault();
      container.scrollLeft += e.deltaX * 1.8; // adjust multiplier for feel
    };

    container.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, []);

  // Touch drag support (grab & move)
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let startX = 0;
    let scrollLeftStart = 0;

    const startDrag = (e) => {
      setIsPaused(true);
      const clientX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      startX = clientX - track.offsetLeft;
      scrollLeftStart = track.scrollLeft;
      track.style.transition = 'none';
    };

    const drag = (e) => {
      if (!isPaused) return;
      e.preventDefault();
      const clientX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      const walk = (clientX - startX) * 2; // scroll speed multiplier
      track.scrollLeft = scrollLeftStart - walk;
    };

    const endDrag = () => {
      setIsPaused(false);
      track.style.transition = '';
    };

    track.addEventListener('mousedown', startDrag);
    track.addEventListener('touchstart', startDrag, { passive: false });
    track.addEventListener('mousemove', drag);
    track.addEventListener('touchmove', drag, { passive: false });
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('touchend', endDrag);
    track.addEventListener('touchcancel', endDrag);

    return () => {
      track.removeEventListener('mousedown', startDrag);
      track.removeEventListener('touchstart', startDrag);
      track.removeEventListener('mousemove', drag);
      track.removeEventListener('touchmove', drag);
      track.removeEventListener('mouseup', endDrag);
      track.removeEventListener('mouseleave', endDrag);
      track.removeEventListener('touchend', endDrag);
      track.removeEventListener('touchcancel', endDrag);
    };
  }, [isPaused]);

  return (
    <section className="py-16 md:py-20 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Patients Say
          </h2>

          <div className="flex items-center justify-center gap-3">
            <div className="flex items-center gap-1.5">
              <span className="text-3xl font-extrabold text-yellow-500">4.9</span>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>
            <span className="text-lg text-gray-600 font-medium">
              Based on 724 reviews
            </span>
          </div>

          <p className="text-gray-500 mt-1 text-sm">powered by Google</p>
        </div>

        {/* Carousel */}
        <div
          ref={containerRef}
          className="relative overflow-hidden cursor-grab active:cursor-grabbing select-none touch-pan-x"
        >
          <div
            ref={trackRef}
            className="flex gap-5 md:gap-6 lg:gap-8 will-change-transform"
            style={{ width: 'max-content' }}
          >
            {/* Original set */}
            {testimonials.map((t, idx) => (
              <div key={idx} className="w-[85vw] sm:w-[380px] lg:w-[340px] flex-shrink-0">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 h-full flex flex-col">
                  <div className="flex items-center gap-3 mb-4">
                    <div
                      className={`w-12 h-12 rounded-full ${t.avatarBg} flex items-center justify-center text-xl font-bold shadow-sm ${t.avatarColor}`}
                    >
                      {t.avatarText}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-lg">{t.name}</h4>
                      <div className="flex text-yellow-400 text-base mt-0.5">
                        {'★'.repeat(t.rating)}
                        {'☆'.repeat(5 - t.rating)}
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-700 leading-relaxed flex-grow text-[15px]">
                    {t.text}
                  </p>
                  <p className="text-sm text-gray-500 mt-5 pt-4 border-t border-gray-100">
                    {t.date}
                  </p>
                </div>
              </div>
            ))}

            {/* Duplicate set for seamless infinite scrolling */}
            {testimonials.map((t, idx) => (
              <div key={`dup-${idx}`} className="w-[85vw] sm:w-[380px] lg:w-[340px] flex-shrink-0" aria-hidden="true">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 h-full flex flex-col">
                  <div className="flex items-center gap-3 mb-4">
                    <div
                      className={`w-12 h-12 rounded-full ${t.avatarBg} flex items-center justify-center text-xl font-bold shadow-sm ${t.avatarColor}`}
                    >
                      {t.avatarText}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-lg">{t.name}</h4>
                      <div className="flex text-yellow-400 text-base mt-0.5">
                        {'★'.repeat(t.rating)}
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-700 leading-relaxed flex-grow text-[15px]">
                    {t.text}
                  </p>
                  <p className="text-sm text-gray-500 mt-5 pt-4 border-t border-gray-100">
                    {t.date}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://www.google.com/search?sca_esv=fce822f8d25e1daa&sxsrf=ANbL-n6U1SyZ4OIY_QXQ6k2luBiWl6z9Tg:1769842024375&si=AL3DRZHrmvnFAVQPOO2Bzhf8AX9KZZ6raUI_dT7DG_z0kV2_x5vecDXR0TvhkvwVLPyiVDnbKxzdwrB9nuYp-j--uvG6PKJwFy-K4xQZnU7c8NZdvQbmsLblkau3QmpL5_FVrLcgV99TKGE9-hZ98sM698wEMm1F3_MpnXSqZ-z2bqTkI0tiuGQ%3D&q=Dr.+Sridhar+International+Dental+Hospital+Reviews&sa=X&ved=2ahUKEwj9n6-pl7WSAxVkJrkGHX2QFLkQ0bkNegQIKRAH&biw=1470&bih=831&dpr=2&aic=0#lrd=0x3a35e54988ce8c69:0x4bf21cdd292f130a,3,,,,"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full transition shadow-lg hover:shadow-xl text-lg"
          >
            Write a Review on Google →
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;